module.exports = __webpack_public_path__ + "static/book-6a9f35f7db77e759bc459a2f996ce6f8.png";